module.exports = __webpack_public_path__ + "img/tema-3-15.a186dd2e.svg";